import type { AccountAccess, AccountRole } from "@/lib/models/accountAccess";

// Un usuario puede tener varios roles de cuenta; manda el de mayor acceso.
// Cada rol incluye todo lo del siguiente: Admin > Finanzas > Comprador > Visualizador.
const accountRolePriority: AccountRole[] = [
  "ACCOUNT_ADMIN",
  "ACCOUNT_FINANCE",
  "ACCOUNT_BUYER",
  "ACCOUNT_VIEWER",
];

export function getEffectiveAccountRole(
  accountRoles: string[],
): AccountRole | null {
  return accountRolePriority.find((role) => accountRoles.includes(role)) ?? null;
}

/**
 * Única fuente de los accesos por rol de cuenta. La usan ability.ts,
 * middleware.ts y validateRoutes.ts para que menú, rutas y UI coincidan.
 * Los clientes sin empresa reciben ACCOUNT_ADMIN sintético en el token.
 */
export function getAccountAccess(accountRoles: string[]): AccountAccess {
  switch (getEffectiveAccountRole(accountRoles)) {
    case "ACCOUNT_ADMIN":
      return {
        accountArea: true,
        orders: true,
        cart: true,
        taxProfile: true,
        billing: true,
        userManagement: true,
      };
    case "ACCOUNT_FINANCE":
      return {
        accountArea: true,
        orders: true,
        cart: true,
        taxProfile: true,
        billing: true,
        userManagement: false,
      };
    case "ACCOUNT_VIEWER":
      return {
        accountArea: false,
        orders: false,
        cart: false,
        taxProfile: false,
        billing: false,
        userManagement: false,
      };
    // Comprador y usuarios sin rol de cuenta. El backend responde 403 en
    // facturación a ambos.
    case "ACCOUNT_BUYER":
    default:
      return {
        accountArea: true,
        orders: true,
        cart: true,
        taxProfile: true,
        billing: false,
        userManagement: false,
      };
  }
}
